import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PlaceDto } from '../places/models';

@Injectable({
  providedIn: 'root',
})
export class UserPlaceService {
  apiName = 'Default';
  

  getCurrentUserAvailablePlaces = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlaceDto[]>({
      method: 'GET',
      url: '/api/app/user-place/current-user-available-places',
    },
    { apiName: this.apiName,...config });
  

  getCurrentUserPlace = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlaceDto>({
      method: 'GET',
      url: '/api/app/user-place/current-user-place',
    },
    { apiName: this.apiName,...config });
  

  updateCurrentUserPlaceByPlaceId = (placeId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/user-place/current-user-place/${placeId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
